import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import styled from 'styled-components'

import Option from 'components/Shared/Select/components/Option'
import SelectControl from './components/SelectControl'
import Menu from './components/Menu'
import DropdownIndicator from './components/DropdownIndicator'
import SingleValue from './components/SingleValue'

const StyledWrapper = styled.div`
  display: flex;
`

const InlineSelect = ({ value, onChange, options, disabled, iconComponentsMap, hideLabel }) => {
  const handleChange = (option) => {
    if (value !== option.value) {
      onChange(option.value)
    }
  }

  const components = {
    IndicatorSeparator: () => null,
    Control: SelectControl,
    Menu: Menu,
    DropdownIndicator: DropdownIndicator,
    SingleValue: SingleValue,
    Option: Option,
  }

  const selectedOption = options.find(option => option.value === value)

  return (
    <StyledWrapper>
      <ReactSelect
        value={selectedOption}
        options={options}
        onChange={handleChange}
        classNamePrefix='react-select'
        components={components}
        isSearchable={false}
        isDisabled={disabled}
        // custom props
        iconComponentsMap={iconComponentsMap}
        hideLabel={hideLabel}
      />
    </StyledWrapper>
  )
}

InlineSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  iconComponentsMap: PropTypes.object,
  hideLabel: PropTypes.bool,
}

export default InlineSelect
